export const storeSelectId = 'storeSelect';
